import axios, { AxiosInstance } from "axios";
import { ApiClient, KpiTrackerConfig } from "../types";

export function createApiClient(config: KpiTrackerConfig): ApiClient {
  const headers: Record<string, string> = {};

  // Add authentication if credentials are provided
  if (config.apiUsername && config.apiPassword) {
    const token = `${config.apiUsername}:${config.apiPassword}`;
    const encodedToken =
      typeof btoa !== "undefined"
        ? btoa(token)
        : Buffer.from(token).toString("base64");
    headers.Authorization = `Basic ${encodedToken}`;
  }

  const axiosInstance: AxiosInstance = axios.create({
    baseURL: config.apiUrl,
    headers,
  });

  return {
    post: (url: string, data: any) => axiosInstance.post(url, data),
    put: (url: string, data: any) => axiosInstance.put(url, data),
    get: (url: string) => axiosInstance.get(url),
  };
}
